import { Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import { useCallback, useEffect, useState } from 'react';

import { useAppSelector, useFormStepIdFromQuery } from 'shared/lib';
import { AdaptiveCard } from 'shared/ui/AdaptiveCard';
import { AppContainer } from 'shared/ui/AppContainer';
import { NoSSR } from 'shared/ui/NoSSR';

import { isAutoValidationInProgressSelector } from 'entities/creditForm';
import { selectIsRestorePage } from 'entities/siteSettings';
import { isLoggedSelector } from 'entities/user';

import { FormSlidesLoader } from 'features/SlidesLoader';
import { useClientRedirect } from 'features/useClientRedirect';

import { Anketa, useAutoValidation } from 'widgets/AnketaWidget';
import { useIsEnabledValidationOnMount } from 'widgets/AnketaWidget/lib';

import { selectPostFormTargetPageName } from 'pageModules/FormPage/lib';

export const FormPage = () => {
  const isMobile = useIsMobile();
  const isRestore = useAppSelector(selectIsRestorePage);
  const isAuth = useAppSelector(isLoggedSelector);
  const isValidating = useAppSelector(isAutoValidationInProgressSelector);
  const { push, prefetch } = useClientRedirect();
  const stepIdFromQuery = useFormStepIdFromQuery();
  const isEnabledValidationOnMount = useIsEnabledValidationOnMount();
  const [isRedirectingToTargetPage, setIsRedirectingToTargetPage] = useState(false);
  const targetPageName = useAppSelector(selectPostFormTargetPageName);
  const isHideRestoredData = isRestore && !isAuth;
  const isLoading = isRedirectingToTargetPage || isValidating;

  const onFormComplete = useCallback(() => {
    setIsRedirectingToTargetPage(true);
    setTimeout(() => push(targetPageName), 300);
  }, [push, setIsRedirectingToTargetPage, targetPageName]);

  useEffect(() => {
    prefetch(targetPageName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { validate } = useAutoValidation(isEnabledValidationOnMount, {
    initialOpenStepId: stepIdFromQuery,
    onFormValidationSuccess: onFormComplete,
  });

  return (
    <FormSlidesLoader isShowLoader={isLoading}>
      <AppContainer hidePaddings={isMobile}>
        <Space
          direction="vertical"
          className={cn('h-pt-24 h-pb-24', { 'h-pl-16 h-pr-16': isMobile })}
          size={32}
        >
          <NoSSR>
            <AdaptiveCard
              desktopSize={24}
              color="light"
            >
              <Anketa
                onFormComplete={onFormComplete}
                isLoading={isLoading}
                isHideRestoredData={isHideRestoredData}
                onAuthorizationSuccess={validate}
              />
            </AdaptiveCard>
          </NoSSR>
        </Space>
      </AppContainer>
    </FormSlidesLoader>
  );
};
